import toggleService from '@/api/toggle'
import notify from '../../api/notification'

const state = {}

const mutations = {}

const getters = {}

const actions = {
  setToggle: function ({ commit }, feature) {
    return toggleService
      .toggleManage(feature)
      .then(response => {
        let unprocessed = response.data
        if (unprocessed && unprocessed.length > 0) {
          notify({
            title: 'AVISO:',
            message: 'Os seguintes laboratórios não foram processados: ' + unprocessed.toString()
          })
        } else {
          notify({ title: 'AVISO:', message: 'Toggle atualizado com sucesso.' })
        }
      })
      .catch(err => {
        console.error(err)
        notify({
          title: 'AVISO:',
          message: 'Ocorreram erros no processamento da sua solicitação.'
        })
      })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
